import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import bg from './locales/bg.json';

// Try to also load nested locale bundles (e.g. src/locales/<lng>/menu.json)
// and merge them into the top-level translation object so menu keys
// are available on app startup without requiring an admin-save reload.
function mergeNestedLocale(base, lang) {
  try {
    // eslint-disable-next-line global-require, import/no-dynamic-require
    const nested = require(`./locales/${lang}/menu.json`);
    if (nested && typeof nested === 'object') {
      return {
        ...base,
        menu: {
          ...(base.menu || {}),
          ...nested,
        },
      };
    }
  } catch (e) {
    // file doesn't exist or couldn't be loaded — that's fine for dev/prod
  }
  return base;
}

const enMerged = mergeNestedLocale(en, 'en');
const bgMerged = mergeNestedLocale(bg, 'bg');

// Add more languages as needed

const savedLanguage = typeof window !== 'undefined'
  ? (localStorage.getItem('menuLanguage') || 'en')
  : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enMerged },
      bg: { translation: bgMerged },
    },
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
